import Repository from "../../repository";

export default {
    Add: (payload) => Repository.post(`/api/TokenApp/Add`, payload),
    AddCustomer: (payload) => Repository.post(`/api/TokenApp/AddCustomer`, payload),
    AddDriver: (payload) => Repository.post(`/api/TokenApp/AddDriver`, payload),
    Delete: (payload) => Repository.post(`/api/TokenApp/Delete`, payload),
    EditLanguage: (payload) => Repository.post(`/api/TokenApp/EditLanguage`, payload),
}
